export default "__VITE_ASSET__C$BpdEpd__"